import React, { useEffect, useRef } from "react";

export default function LiveRecordingWaveform({ analyser, paused = false }) {
	const canvasRef = useRef(null);
	const levels = useRef([]);

	useEffect(() => { levels.current = []; }, [analyser]);

	useEffect(() => {
		if (!analyser || !canvasRef.current) return;
		const canvas = canvasRef.current;
		const context = canvas.getContext("2d");
		if (!context) return;
		const samples = new Uint8Array(analyser.fftSize);
		const draw = () => {
			const width = canvas.clientWidth;
			const height = canvas.clientHeight;
			if (!width || !height) return;
			const count = Math.max(1, Math.min(80, Math.floor(width / 5)));
			if (!paused) {
				analyser.getByteTimeDomainData(samples);
				let squareSum = 0;
				for (const sample of samples) squareSum += ((sample - 128) / 128) ** 2;
				const level = Math.min(1, Math.sqrt(squareSum / samples.length) * 5);
				levels.current = [...levels.current.slice(-79), level];
			}
			const ratio = window.devicePixelRatio || 1;
			canvas.width = Math.round(width * ratio);
			canvas.height = Math.round(height * ratio);
			context.setTransform(ratio, 0, 0, ratio, 0, 0);
			context.clearRect(0, 0, width, height);
			context.fillStyle = paused ? "#868e96" : getComputedStyle(canvas).getPropertyValue("--app-accent-blue").trim() || "#29a9eb";
			context.globalAlpha = paused ? 0.5 : 1;
			const bars = [...Array(Math.max(0, count - levels.current.length)).fill(0), ...levels.current.slice(-count)];
			bars.forEach((level, index) => {
				const barHeight = 3 + level * 29;
				context.fillRect(index * (width / count), (height - barHeight) / 2, 2.5, barHeight);
			});
		};
		draw();
		const timer = setInterval(draw, 100);
		return () => clearInterval(timer);
	}, [analyser, paused]);

	return <canvas ref={canvasRef} aria-label={paused ? "Recording paused" : "Live recording waveform"} role="img"
		style={{ display: "block", width: "100%", height: 36 }} />;
}
